import React from 'react';

import PropTypes from 'prop-types';
import { ContinueButton, RegistrationModalContentContainer } from './UAMLoginRegistrationModalStyles';
import UAMModal from '../../UAMModal/UAMModal';

const UAMLoginRegistrationModal = ({ continueClickedFn }) => (
  <UAMModal
    cancelDeactivatesModal={false}
    headerContent="Let's Confirm a Few Details"
    footerContent={(
      <>
        <ContinueButton
          id="continue-registration"
          primary
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            continueClickedFn();
          }}
        >
          Continue
        </ContinueButton>
      </>
      )}
    showCloseNav={false}
    initialFocus="#continue-registration"
  >
    <RegistrationModalContentContainer>
      We&apos;ve made some enhancements to account management and security.{' '}
      Before you continue, please take a few moments to confirm a few {' '}
      account details.
    </RegistrationModalContentContainer>
  </UAMModal>
);

UAMLoginRegistrationModal.propTypes = {
  continueClickedFn: PropTypes.func.isRequired,
};

export default UAMLoginRegistrationModal;
